module.exports = __webpack_public_path__ + "uia-one-page.2d2fa86fa3ea58e4582d8f77a1495f94.svg";